module.exports = __webpack_public_path__ + "static/media/tele.38237568.svg";